<template>
  <!-- 资产类型管理 -->
  <div class="app-control-right-cr" v-loading="loaded">
    <!-- 标题 -->
    <PropertyTypeTitle ref="PropertyTypeTitle"></PropertyTypeTitle>
    <!-- 主内容 -->
    <PropertyTypeTable v-if="PropertyTypeTableData !== undefined" :property-type-table-data="PropertyTypeTableData"
                       v-loading="tableLoad"></PropertyTypeTable>
    <!-- 编辑浮窗 -->
    <EditPropertyType ref="EditPropertyType" :add-mode="editDialogMode"></EditPropertyType>
  </div>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import util from "@/components/util";
import PropertyTypeTitle from "@/views/control/components/property/PropertyType/PropertyTypeTitle";
import PropertyTypeTable from "@/views/control/components/property/PropertyType/PropertyTypeTable";
import EditPropertyType from "@/views/control/components/property/PropertyType/EditPropertyType";

export default {
  name: "PropertyTypeControl",
  components: {
    EditPropertyType,
    PropertyTypeTable,
    PropertyTypeTitle
  },
  data() {
    return {
      PropertyTypeTableData: [],
      loaded: true,
      tableLoad: false,
      editDialogMode: undefined,
    }
  },
  beforeMount() {
    this.getPropertyTypeData()
  },
  methods: {
    //获取资产类型列表
    getPropertyTypeData() {
      this.tableLoad = true;
      this.propertyCodeTableData = undefined;
      AxiosBase.axiosGet("/property-ad/get-property-type").then(response => {
        if (response !== 0) {
          response.data.forEach(jsonObject => {
            jsonObject.trackTime = util.dateFormat("YYYY-mm-dd HH:MM:SS", new Date(jsonObject.trackTime))
          });
          this.PropertyTypeTableData = response.data;
          this.tableLoad = false;
          this.loaded = false;
        }
      })
    },
    openEditDialog(mode) {
      this.$refs.EditPropertyType.dialogFormVisible = true;
      this.editDialogMode = mode === "add";
    }
  },
}
</script>

